<app-page-breadcrumb pageTitle="Avatars" />
<div class="space-y-5 sm:space-y-6">
  <div>
    <app-component-card title="Default Avatar">
      <div class="flex flex-col items-center justify-center gap-5 sm:flex-row">
        <app-avatar src="/images/user/user-01.jpg" size="xsmall" />
        <app-avatar src="/images/user/user-01.jpg" size="small" />
        <app-avatar src="/images/user/user-01.jpg" size="medium" />
        <app-avatar src="/images/user/user-01.jpg" size="large" />
        <app-avatar src="/images/user/user-01.jpg" size="xlarge" />
        <app-avatar src="/images/user/user-01.jpg" size="xxlarge" />
      </div>
    </app-component-card>
  </div>

  <div>
    <app-component-card title="Avatar with online indicator">
      <div class="flex flex-col items-center justify-center gap-5 sm:flex-row">
        <app-avatar
          src="/images/user/user-01.jpg"
          size="xsmall"
          status="online"
        />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="small"
          status="online"
        />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="medium"
          status="online"
        />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="large"
          status="online"
        />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="xlarge"
          status="online"
        />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="xxlarge"
          status="online"
        />
      </div>
    </app-component-card>
  </div>

  <div>
    <app-component-card title="Avatar with Offline indicator">
      <div class="flex flex-col items-center justify-center gap-5 sm:flex-row">
        <app-avatar
          src="/images/user/user-01.jpg"
          size="xsmall"
          status="offline"
        />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="small"
          status="offline"
        />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="medium"
          status="offline"
        />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="large"
          status="offline"
        />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="xlarge"
          status="offline"
        />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="xxlarge"
          status="offline"
        />
      </div>
    </app-component-card>
  </div>

  <div>
    <app-component-card title="Avatar with busy indicator">
      <div class="flex flex-col items-center justify-center gap-5 sm:flex-row">
        <app-avatar
          src="/images/user/user-01.jpg"
          size="xsmall"
          status="busy"
        />
        <app-avatar src="/images/user/user-01.jpg" size="small" status="busy" />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="medium"
          status="busy"
        />
        <app-avatar src="/images/user/user-01.jpg" size="large" status="busy" />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="xlarge"
          status="busy"
        />
        <app-avatar
          src="/images/user/user-01.jpg"
          size="xxlarge"
          status="busy"
        />
      </div>
    </app-component-card>
  </div>
</div>
